import('./bootstrap')
	.catch(err => err);
